module.exports = __webpack_public_path__ + "04_face.3cff5a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/04_face.png
// module id = xmmH
// module chunks = 0